import { PROFILE_VIEW } from "./types";

export const profileView = (data, onSuccess, onError) => {
    return {
        type: PROFILE_VIEW,
        data,
        onSuccess,
        onError,
    };
};
